import { Pipe, PipeTransform } from '@angular/core';
import { ManualSection } from './manual-content';

@Pipe({
  name: 'manualSearch'
})
export class ManualSearchPipe implements PipeTransform {
  transform(sections: ManualSection[], searchText: string, audienceFilter: string): ManualSection[] {
    if (!sections) return [];

    let filtered = sections;

    // Filter by audience
    if (audienceFilter && audienceFilter !== 'all') {
      filtered = filtered.filter(s => s.audience === 'both' || s.audience === audienceFilter);
      filtered = filtered.map(s => ({
        ...s,
        subsections: s.subsections.filter(sub => sub.audience === 'both' || sub.audience === audienceFilter)
      })).filter(s => s.subsections.length > 0);
    }

    // Filter by search text
    if (searchText && searchText.trim().length > 0) {
      const search = searchText.toLowerCase().trim();
      filtered = filtered.filter(s => {
        const sectionMatches = s.title.toLowerCase().includes(search);
        const matchingSubsections = s.subsections.filter(sub =>
          sub.title.toLowerCase().includes(search) ||
          sub.content.toLowerCase().includes(search)
        );
        return sectionMatches || matchingSubsections.length > 0;
      }).map(s => {
        const sectionMatches = s.title.toLowerCase().includes(search);
        if (sectionMatches) {
          return s;
        }
        const matchingSubsections = s.subsections.filter(sub =>
          sub.title.toLowerCase().includes(search) ||
          sub.content.toLowerCase().includes(search)
        );
        return { ...s, subsections: matchingSubsections };
      });
    }

    return filtered;
  }
}
